import { DckActionTypes } from "dck-redux"
import { all, takeEvery } from "redux-saga/effects"
import * as ItemTypes from "../../items/types"
import apiServerConstants from "../apiServerConstants"
import processTypes from "../../processes/types"
import { HTTP_VERB } from "../../../lib/utils"
import { makeSagaQuery } from "../utils"
import CountryCodes from "../../../components/Settings/CountryCodes"

function *loadAgeSettings() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/agesettings`, 
    HTTP_VERB.GET,
    null,
    processTypes.AGE_SETTING,
    true,
    response => {

      const data = response.body
      if (!(data instanceof Array)) return

      data.sort((a, b) => {

        if(a.countryCode === 'default' || b.countryCode === 'default') return 1
  
        const cc1 = CountryCodes[a.countryCode],
        cc2 = CountryCodes[b.countryCode]
        return cc1.localeCompare(cc2)
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.AgeSetting,
        data
      }
    }
  )
}

function *saveAgeSetting(action) {

  yield makeSagaQuery(
    `${apiServerConstants.host}/agesettings`, 
    HTTP_VERB.POST,
    JSON.stringify(action.data),
    processTypes.SAVE_AGE_SETTING,
    true,
    response => ({
      type: "SAVE_RESULT",
      itemType: ItemTypes.AgeSetting,
      data: response.body
    })
  )
}

function *updateAgeSetting(action) {

  yield makeSagaQuery(
    `${apiServerConstants.host}/agesettings/${action.id}`,
    HTTP_VERB.PUT,
    JSON.stringify(action.data),
    processTypes.UPDATE_AGE_SETTING,
    true,
    response => ({
      type: 'UPDATE_RESULT',
      itemType: ItemTypes.AgeSetting,
      data: response.body
    })
  )
}

function *removeAgeSetting(action) {

  yield makeSagaQuery(
    `${apiServerConstants.host}/agesettings/${action.id}`,
    HTTP_VERB.DELETE,
    null,
    processTypes.DELETE_AGE_SETTING,
    true,
    () => ({
      type: 'DELETE_RESULT',
      itemType: ItemTypes.AgeSetting,
    })
  )
}

function *loadQRCodesHistorical() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/commander/qrhistorical`, 
    HTTP_VERB.GET,
    null,
    processTypes.LOAD_QRCODE_PROCESS,
    true,
    response => ({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.QRCode,
      data: response.body
    })
  )
}

function *updateQRCodesHistorical() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/commander/updateqrhistorical`, 
    HTTP_VERB.POST,
    null,
    processTypes.UPDATE_QRCODE_PROCESS,
    true,
    response => ({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.QRCode,
      data: response.body
    })
  )
}

function *settingsSaga() {

  yield all([

    takeEvery(action => 
      action.type === DckActionTypes.ITEMS_LOAD &&
      action.itemType === ItemTypes.AgeSetting,
      loadAgeSettings),

    takeEvery(action => 
      action.type === DckActionTypes.ITEM_ADD &&
      action.itemType === ItemTypes.AgeSetting,
      saveAgeSetting),

    takeEvery(action =>
      action.type === DckActionTypes.ITEM_SAVE &&
      action.itemType === ItemTypes.AgeSetting,
      updateAgeSetting),

    takeEvery(action => 
      action.type === DckActionTypes.ITEM_REMOVE &&
      action.itemType === ItemTypes.AgeSetting,
      removeAgeSetting),

    takeEvery(action => 
      action.type === DckActionTypes.ITEMS_LOAD &&
      action.itemType === ItemTypes.QRCode,
      loadQRCodesHistorical),

    takeEvery(action => 
      action.type === DckActionTypes.ITEMS_LOAD &&
      action.itemType === ItemTypes.UpdateQRCode,
      updateQRCodesHistorical),
  ])
}

export default settingsSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/settings.js